/**
 * 权限检查工具函数
 */

import { ROLES } from '../types/role';
import type { CurrentUser } from '../services/authService';

export class PermissionUtils {
  /**
   * 检查用户是否有指定角色
   */
  static hasRole(user: CurrentUser | null, role: string): boolean {
    if (!user || !user.roles) return false;
    return user.roles.includes(role);
  }

  /**
   * 检查用户是否有任意一个指定角色
   */
  static hasAnyRole(user: CurrentUser | null, roles: string[]): boolean {
    if (!user || !user.roles) return false;
    return roles.some(role => user.roles!.includes(role));
  }

  /**
   * 检查用户是否是管理员（admin 或 super_admin）
   */
  static isAdmin(user: CurrentUser | null): boolean {
    return this.hasAnyRole(user, [ROLES.ADMIN, ROLES.SUPER_ADMIN]);
  }

  /**
   * 检查用户是否是超级管理员
   */
  static isSuperAdmin(user: CurrentUser | null): boolean {
    return this.hasRole(user, ROLES.SUPER_ADMIN);
  }

  /**
   * 检查用户是否可以管理其他用户
   */
  static canManageUsers(user: CurrentUser | null): boolean {
    return this.hasAnyRole(user, [ROLES.MANAGER, ROLES.ADMIN, ROLES.SUPER_ADMIN]);
  }

  /**
   * 检查用户是否可以访问员工管理页面
   */
  static canAccessUserManagement(user: CurrentUser | null): boolean {
    // 目前只有管理员和超级管理员能访问员工管理
    return this.isAdmin(user);
  }

  /**
   * 检查用户是否可以访问角色管理页面
   */
  static canAccessRoleManagement(user: CurrentUser | null): boolean {
    // 目前只有管理员和超级管理员能访问角色管理
    return this.isAdmin(user);
  }
}
